/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LandingConfiguration } from './LandingConfiguration';
import {
	LandingConfigurationFromJSON,
	LandingConfigurationFromJSONTyped,
	LandingConfigurationToJSON,
	LandingConfigurationToJSONTyped,
} from './LandingConfiguration';
import type { ProductType } from './ProductType';
import {
	ProductTypeFromJSON,
	ProductTypeFromJSONTyped,
	ProductTypeToJSON,
	ProductTypeToJSONTyped,
} from './ProductType';
import type { EasyClaimFrontendStep } from './EasyClaimFrontendStep';
import {
	EasyClaimFrontendStepFromJSON,
	EasyClaimFrontendStepFromJSONTyped,
	EasyClaimFrontendStepToJSON,
	EasyClaimFrontendStepToJSONTyped,
} from './EasyClaimFrontendStep';
import type { EasyClaimDataPrivacyLink } from './EasyClaimDataPrivacyLink';
import {
	EasyClaimDataPrivacyLinkFromJSON,
	EasyClaimDataPrivacyLinkFromJSONTyped,
	EasyClaimDataPrivacyLinkToJSON,
	EasyClaimDataPrivacyLinkToJSONTyped,
} from './EasyClaimDataPrivacyLink';

/**
 *
 * @export
 * @interface EasyClaimCustomerConfigurationDto
 */
export interface EasyClaimCustomerConfigurationDto {
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	companyShortName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	feedbackAfterAuditUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	feedbackAfterFinishedUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	applicationName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	primaryColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	secondaryColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	backgroundUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	primaryTextColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	secondaryTextColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	iconPrimaryColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	iconSecondaryColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	iconActivePrimaryColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	iconActiveSecondaryColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	landingPrimaryColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	landingPrimaryTextColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	landingSecondaryTextColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	landingIconPrimaryColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	landingIconSecondaryColor?: string | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	landingHideBackgroundGradient?: boolean | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	successColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	infoColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	warningColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	dangerColor?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	imprint?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	imprintUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	hotlineNumber?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	termsAndConditions?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	dataPrivacyUrl?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	toOfficeHours?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	fromOfficeHours?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	serviceTimes?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	toOfficeDay?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	fromOfficeDay?: string | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	allowDownloadCalculationFile?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	allowDownloadCalculationFileOnFinishedView?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	isDataPrivacyVisible?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	isMenuVisible?: boolean | null;
	/**
	 *
	 * @type {Array<EasyClaimFrontendStep>}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	frontendSteps?: Array<EasyClaimFrontendStep> | null;
	/**
	 *
	 * @type {ProductType}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	layout?: ProductType;
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	minimalImageFirstAxis?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	minimalImageSecondAxis?: number | null;
	/**
	 *
	 * @type {Array<EasyClaimDataPrivacyLink>}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	dataPrivacyLinks?: Array<EasyClaimDataPrivacyLink> | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	isLandingStepsGridVisible?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	isLandingParagraphVisible?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	readonly useVinWindshieldImge?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	isLandingLinkDescriptionVisible?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	useFileInputCameraCapture?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	allowAutoMoveNext?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	showHelpButton?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	allowSkipVehicleInformation?: boolean | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	additionalStyleFileName?: string | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	doNotAllowDesktop?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	compressImages?: boolean;
	/**
	 *
	 * @type {LandingConfiguration}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	landingConfiguration?: LandingConfiguration;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	enableMotorbikesSupport?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	isImageUploadProgressBarVisible?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	isFileDeletionDisabled?: boolean;
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	customerFeedbackMaxLength?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	maximumMileagePhotoUploadAttemptsBeforeManualInput?: number | null;
	/**
	 *
	 * @type {number}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	additionalDamagePicturesLimit?: number | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	canScrollToMissingPhoto?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	canShowOverlayOnCamera?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	canUseExperimentalPerformanceEnhancer?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	showUpdatedVerificationResults?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	optionalMileageTextInput?: boolean | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	canDetectDarkPictureLive?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	additionalDamagePicturesRequired?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	useSolvdStyles?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	isFullscreenPromptEnabled?: boolean;
	/**
	 *
	 * @type {boolean}
	 * @memberof EasyClaimCustomerConfigurationDto
	 */
	deletePhotoConfirmation?: boolean | null;
}

/**
 * Check if a given object implements the EasyClaimCustomerConfigurationDto interface.
 */
export function instanceOfEasyClaimCustomerConfigurationDto(
	value: object
): value is EasyClaimCustomerConfigurationDto {
	return true;
}

export function EasyClaimCustomerConfigurationDtoFromJSON(
	json: any
): EasyClaimCustomerConfigurationDto {
	return EasyClaimCustomerConfigurationDtoFromJSONTyped(json, false);
}

export function EasyClaimCustomerConfigurationDtoFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimCustomerConfigurationDto {
	if (json == null) {
		return json;
	}
	return {
		companyShortName: json['companyShortName'] == null ? undefined : json['companyShortName'],
		feedbackAfterAuditUrl:
			json['feedbackAfterAuditUrl'] == null ? undefined : json['feedbackAfterAuditUrl'],
		feedbackAfterFinishedUrl:
			json['feedbackAfterFinishedUrl'] == null ? undefined : json['feedbackAfterFinishedUrl'],
		applicationName: json['applicationName'] == null ? undefined : json['applicationName'],
		primaryColor: json['primaryColor'] == null ? undefined : json['primaryColor'],
		secondaryColor: json['secondaryColor'] == null ? undefined : json['secondaryColor'],
		backgroundUrl: json['backgroundUrl'] == null ? undefined : json['backgroundUrl'],
		primaryTextColor: json['primaryTextColor'] == null ? undefined : json['primaryTextColor'],
		secondaryTextColor: json['secondaryTextColor'] == null ? undefined : json['secondaryTextColor'],
		iconPrimaryColor: json['iconPrimaryColor'] == null ? undefined : json['iconPrimaryColor'],
		iconSecondaryColor: json['iconSecondaryColor'] == null ? undefined : json['iconSecondaryColor'],
		iconActivePrimaryColor:
			json['iconActivePrimaryColor'] == null ? undefined : json['iconActivePrimaryColor'],
		iconActiveSecondaryColor:
			json['iconActiveSecondaryColor'] == null ? undefined : json['iconActiveSecondaryColor'],
		landingPrimaryColor:
			json['landingPrimaryColor'] == null ? undefined : json['landingPrimaryColor'],
		landingPrimaryTextColor:
			json['landingPrimaryTextColor'] == null ? undefined : json['landingPrimaryTextColor'],
		landingSecondaryTextColor:
			json['landingSecondaryTextColor'] == null ? undefined : json['landingSecondaryTextColor'],
		landingIconPrimaryColor:
			json['landingIconPrimaryColor'] == null ? undefined : json['landingIconPrimaryColor'],
		landingIconSecondaryColor:
			json['landingIconSecondaryColor'] == null ? undefined : json['landingIconSecondaryColor'],
		landingHideBackgroundGradient:
			json['landingHideBackgroundGradient'] == null
				? undefined
				: json['landingHideBackgroundGradient'],
		successColor: json['successColor'] == null ? undefined : json['successColor'],
		infoColor: json['infoColor'] == null ? undefined : json['infoColor'],
		warningColor: json['warningColor'] == null ? undefined : json['warningColor'],
		dangerColor: json['dangerColor'] == null ? undefined : json['dangerColor'],
		imprint: json['imprint'] == null ? undefined : json['imprint'],
		imprintUrl: json['imprintUrl'] == null ? undefined : json['imprintUrl'],
		hotlineNumber: json['hotlineNumber'] == null ? undefined : json['hotlineNumber'],
		termsAndConditions: json['termsAndConditions'] == null ? undefined : json['termsAndConditions'],
		dataPrivacyUrl: json['dataPrivacyUrl'] == null ? undefined : json['dataPrivacyUrl'],
		toOfficeHours: json['toOfficeHours'] == null ? undefined : json['toOfficeHours'],
		fromOfficeHours: json['fromOfficeHours'] == null ? undefined : json['fromOfficeHours'],
		serviceTimes: json['serviceTimes'] == null ? undefined : json['serviceTimes'],
		toOfficeDay: json['toOfficeDay'] == null ? undefined : json['toOfficeDay'],
		fromOfficeDay: json['fromOfficeDay'] == null ? undefined : json['fromOfficeDay'],
		allowDownloadCalculationFile:
			json['allowDownloadCalculationFile'] == null
				? undefined
				: json['allowDownloadCalculationFile'],
		allowDownloadCalculationFileOnFinishedView:
			json['allowDownloadCalculationFileOnFinishedView'] == null
				? undefined
				: json['allowDownloadCalculationFileOnFinishedView'],
		isDataPrivacyVisible:
			json['isDataPrivacyVisible'] == null ? undefined : json['isDataPrivacyVisible'],
		isMenuVisible: json['isMenuVisible'] == null ? undefined : json['isMenuVisible'],
		frontendSteps:
			json['frontendSteps'] == null
				? undefined
				: (json['frontendSteps'] as Array<any>).map(EasyClaimFrontendStepFromJSON),
		layout: json['layout'] == null ? undefined : ProductTypeFromJSON(json['layout']),
		minimalImageFirstAxis:
			json['minimalImageFirstAxis'] == null ? undefined : json['minimalImageFirstAxis'],
		minimalImageSecondAxis:
			json['minimalImageSecondAxis'] == null ? undefined : json['minimalImageSecondAxis'],
		dataPrivacyLinks:
			json['dataPrivacyLinks'] == null
				? undefined
				: (json['dataPrivacyLinks'] as Array<any>).map(EasyClaimDataPrivacyLinkFromJSON),
		isLandingStepsGridVisible:
			json['isLandingStepsGridVisible'] == null ? undefined : json['isLandingStepsGridVisible'],
		isLandingParagraphVisible:
			json['isLandingParagraphVisible'] == null ? undefined : json['isLandingParagraphVisible'],
		useVinWindshieldImge:
			json['useVinWindshieldImge'] == null ? undefined : json['useVinWindshieldImge'],
		isLandingLinkDescriptionVisible:
			json['isLandingLinkDescriptionVisible'] == null
				? undefined
				: json['isLandingLinkDescriptionVisible'],
		useFileInputCameraCapture:
			json['useFileInputCameraCapture'] == null ? undefined : json['useFileInputCameraCapture'],
		allowAutoMoveNext: json['allowAutoMoveNext'] == null ? undefined : json['allowAutoMoveNext'],
		showHelpButton: json['showHelpButton'] == null ? undefined : json['showHelpButton'],
		allowSkipVehicleInformation:
			json['allowSkipVehicleInformation'] == null ? undefined : json['allowSkipVehicleInformation'],
		additionalStyleFileName:
			json['additionalStyleFileName'] == null ? undefined : json['additionalStyleFileName'],
		doNotAllowDesktop: json['doNotAllowDesktop'] == null ? undefined : json['doNotAllowDesktop'],
		compressImages: json['compressImages'] == null ? undefined : json['compressImages'],
		landingConfiguration:
			json['landingConfiguration'] == null
				? undefined
				: LandingConfigurationFromJSON(json['landingConfiguration']),
		enableMotorbikesSupport:
			json['enableMotorbikesSupport'] == null ? undefined : json['enableMotorbikesSupport'],
		isImageUploadProgressBarVisible:
			json['isImageUploadProgressBarVisible'] == null
				? undefined
				: json['isImageUploadProgressBarVisible'],
		isFileDeletionDisabled:
			json['isFileDeletionDisabled'] == null ? undefined : json['isFileDeletionDisabled'],
		customerFeedbackMaxLength:
			json['customerFeedbackMaxLength'] == null ? undefined : json['customerFeedbackMaxLength'],
		maximumMileagePhotoUploadAttemptsBeforeManualInput:
			json['maximumMileagePhotoUploadAttemptsBeforeManualInput'] == null
				? undefined
				: json['maximumMileagePhotoUploadAttemptsBeforeManualInput'],
		additionalDamagePicturesLimit:
			json['additionalDamagePicturesLimit'] == null
				? undefined
				: json['additionalDamagePicturesLimit'],
		canScrollToMissingPhoto:
			json['canScrollToMissingPhoto'] == null ? undefined : json['canScrollToMissingPhoto'],
		canShowOverlayOnCamera:
			json['canShowOverlayOnCamera'] == null ? undefined : json['canShowOverlayOnCamera'],
		canUseExperimentalPerformanceEnhancer:
			json['canUseExperimentalPerformanceEnhancer'] == null
				? undefined
				: json['canUseExperimentalPerformanceEnhancer'],
		showUpdatedVerificationResults:
			json['showUpdatedVerificationResults'] == null
				? undefined
				: json['showUpdatedVerificationResults'],
		optionalMileageTextInput:
			json['optionalMileageTextInput'] == null ? undefined : json['optionalMileageTextInput'],
		canDetectDarkPictureLive:
			json['canDetectDarkPictureLive'] == null ? undefined : json['canDetectDarkPictureLive'],
		additionalDamagePicturesRequired:
			json['additionalDamagePicturesRequired'] == null
				? undefined
				: json['additionalDamagePicturesRequired'],
		useSolvdStyles: json['useSolvdStyles'] == null ? undefined : json['useSolvdStyles'],
		isFullscreenPromptEnabled:
			json['isFullscreenPromptEnabled'] == null ? undefined : json['isFullscreenPromptEnabled'],
		deletePhotoConfirmation:
			json['deletePhotoConfirmation'] == null ? undefined : json['deletePhotoConfirmation'],
	};
}

export function EasyClaimCustomerConfigurationDtoToJSON(
	json: any
): EasyClaimCustomerConfigurationDto {
	return EasyClaimCustomerConfigurationDtoToJSONTyped(json, false);
}

export function EasyClaimCustomerConfigurationDtoToJSONTyped(
	value?: Omit<EasyClaimCustomerConfigurationDto, 'useVinWindshieldImge'> | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		companyShortName: value['companyShortName'],
		feedbackAfterAuditUrl: value['feedbackAfterAuditUrl'],
		feedbackAfterFinishedUrl: value['feedbackAfterFinishedUrl'],
		applicationName: value['applicationName'],
		primaryColor: value['primaryColor'],
		secondaryColor: value['secondaryColor'],
		backgroundUrl: value['backgroundUrl'],
		primaryTextColor: value['primaryTextColor'],
		secondaryTextColor: value['secondaryTextColor'],
		iconPrimaryColor: value['iconPrimaryColor'],
		iconSecondaryColor: value['iconSecondaryColor'],
		iconActivePrimaryColor: value['iconActivePrimaryColor'],
		iconActiveSecondaryColor: value['iconActiveSecondaryColor'],
		landingPrimaryColor: value['landingPrimaryColor'],
		landingPrimaryTextColor: value['landingPrimaryTextColor'],
		landingSecondaryTextColor: value['landingSecondaryTextColor'],
		landingIconPrimaryColor: value['landingIconPrimaryColor'],
		landingIconSecondaryColor: value['landingIconSecondaryColor'],
		landingHideBackgroundGradient: value['landingHideBackgroundGradient'],
		successColor: value['successColor'],
		infoColor: value['infoColor'],
		warningColor: value['warningColor'],
		dangerColor: value['dangerColor'],
		imprint: value['imprint'],
		imprintUrl: value['imprintUrl'],
		hotlineNumber: value['hotlineNumber'],
		termsAndConditions: value['termsAndConditions'],
		dataPrivacyUrl: value['dataPrivacyUrl'],
		toOfficeHours: value['toOfficeHours'],
		fromOfficeHours: value['fromOfficeHours'],
		serviceTimes: value['serviceTimes'],
		toOfficeDay: value['toOfficeDay'],
		fromOfficeDay: value['fromOfficeDay'],
		allowDownloadCalculationFile: value['allowDownloadCalculationFile'],
		allowDownloadCalculationFileOnFinishedView: value['allowDownloadCalculationFileOnFinishedView'],
		isDataPrivacyVisible: value['isDataPrivacyVisible'],
		isMenuVisible: value['isMenuVisible'],
		frontendSteps:
			value['frontendSteps'] == null
				? undefined
				: (value['frontendSteps'] as Array<any>).map(EasyClaimFrontendStepToJSON),
		layout: ProductTypeToJSON(value['layout']),
		minimalImageFirstAxis: value['minimalImageFirstAxis'],
		minimalImageSecondAxis: value['minimalImageSecondAxis'],
		dataPrivacyLinks:
			value['dataPrivacyLinks'] == null
				? undefined
				: (value['dataPrivacyLinks'] as Array<any>).map(EasyClaimDataPrivacyLinkToJSON),
		isLandingStepsGridVisible: value['isLandingStepsGridVisible'],
		isLandingParagraphVisible: value['isLandingParagraphVisible'],
		isLandingLinkDescriptionVisible: value['isLandingLinkDescriptionVisible'],
		useFileInputCameraCapture: value['useFileInputCameraCapture'],
		allowAutoMoveNext: value['allowAutoMoveNext'],
		showHelpButton: value['showHelpButton'],
		allowSkipVehicleInformation: value['allowSkipVehicleInformation'],
		additionalStyleFileName: value['additionalStyleFileName'],
		doNotAllowDesktop: value['doNotAllowDesktop'],
		compressImages: value['compressImages'],
		landingConfiguration: LandingConfigurationToJSON(value['landingConfiguration']),
		enableMotorbikesSupport: value['enableMotorbikesSupport'],
		isImageUploadProgressBarVisible: value['isImageUploadProgressBarVisible'],
		isFileDeletionDisabled: value['isFileDeletionDisabled'],
		customerFeedbackMaxLength: value['customerFeedbackMaxLength'],
		maximumMileagePhotoUploadAttemptsBeforeManualInput:
			value['maximumMileagePhotoUploadAttemptsBeforeManualInput'],
		additionalDamagePicturesLimit: value['additionalDamagePicturesLimit'],
		canScrollToMissingPhoto: value['canScrollToMissingPhoto'],
		canShowOverlayOnCamera: value['canShowOverlayOnCamera'],
		canUseExperimentalPerformanceEnhancer: value['canUseExperimentalPerformanceEnhancer'],
		showUpdatedVerificationResults: value['showUpdatedVerificationResults'],
		optionalMileageTextInput: value['optionalMileageTextInput'],
		canDetectDarkPictureLive: value['canDetectDarkPictureLive'],
		additionalDamagePicturesRequired: value['additionalDamagePicturesRequired'],
		useSolvdStyles: value['useSolvdStyles'],
		isFullscreenPromptEnabled: value['isFullscreenPromptEnabled'],
		deletePhotoConfirmation: value['deletePhotoConfirmation'],
	};
}
